const CommentEmpty = () => {
  return ( 
    <span>No comments</span>
  );
}
 
export default CommentEmpty;